module.exports = __webpack_public_path__ + "img/zsfwct1.27f90ca3.png";